import { i18n, inject, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { BSPOptionsStore } from "./BSPOptionsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: BSPOptionsStore;
}

@inject("externalInterfaceStore")
@observer
export class BSPOptionsSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                message={ui.__(this.props.store.selectedPayout ? "bspOptions.success.text" : "bspOptions.success.bonus.text")}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsSuccess.tsx